import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { ROUTES } from '@/config/routes';

interface CartButtonProps {
  /** Number of items in the cart; drives the badge and the aria-label. */
  count: number;
}

/**
 * Cart shortcut shown beside the property search. Links to the cart page
 * and surfaces the current item count as a badge.
 */
export function CartButton({ count }: CartButtonProps) {
  return (
    <Link
      to={ROUTES.ORDERS_CART}
      aria-label={`View cart (${count} ${count === 1 ? 'item' : 'items'})`}
      className="relative inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-border text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/25 max-lg:h-11 max-lg:w-11"
    >
      <ShoppingCart className="h-5 w-5" />
      {count > 0 && (
        <span
          aria-hidden="true"
          className="absolute -top-1.5 -right-1.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground"
        >
          {count}
        </span>
      )}
    </Link>
  );
}
